import { create } from "zustand";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "../constants";
import { getAppLangLocal, setAppLangLocal } from "../utils/utils";

export const useAppStore = create((set, get) => ({
  appLang: getAppLangLocal() ?? DEFAULT_LANG,
  setAppLang: (value) => {
    if (!SUPPORTED_LANGS.includes(value)) return;
    setAppLangLocal(value);
    set({
      appLang: SUPPORTED_LANGS.includes(value) ? value : DEFAULT_LANG,
    });
  },
}));
